import React from "react";
import InvoiceApprovalList from "../../features/InvoiceApprovalList/InvoiceApprovalList";

const InvoiceApproval = () => {
  return (
    <div className="analytics-page">
      <InvoiceApprovalList />
    </div>
  );
};

export default InvoiceApproval;
